import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { COUNTRY_ACTION_TYPE } from "./country.action";
import { CountryState, GetCountriesResponse, GetCountryStatesResponse } from "./country.model";

const initialState: CountryState = {};

export function countryReducer(state = initialState, action: ActionWithPayload): CountryState {
	switch (action.type) {
		case COUNTRY_ACTION_TYPE.getAllSuccess: {
			const payload: GetCountriesResponse = action.payload;

			return updateState(state, {
				countries: payload.countries,
				currentSupportedCountry: payload.currentCountry,
			});
		}
		case COUNTRY_ACTION_TYPE.getAllStatesSuccess:
		case COUNTRY_ACTION_TYPE.getAllStatesFromContentSuccess: {
			const payload: GetCountryStatesResponse = action.payload;

			return updateState(state, {
				states: payload.states,
			});
		}
		case COUNTRY_ACTION_TYPE.getAllBirthCountriesSuccess: {
			const payload: GetCountriesResponse = action.payload;

			return updateState(state, {
				birthCountries: payload.countries,
			});
		}
		case COUNTRY_ACTION_TYPE.getAdministrativeAreasSuccess: {
			const { response, countryCode } = action.payload;

			return updateState(state, {
				administrativeAreasByCountryCode: {
					...state.administrativeAreasByCountryCode,
					[countryCode]: response,
				},
			});
		}
		default:
			return state;
	}
}
